import { DataSourceAction, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutFuelDetailHistory } from "./autogen/AutogenLayoutFuelDetailHistory";
import { ModelRow } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";

export class FuelDetailHistory extends AutogenLayoutFuelDetailHistory {

    sourceFuelDetailHistAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            const fuelTotals = this.activeRow.get("fuel_totals", []);
            const fuelRows = fuelTotals.map((data) => this.createFuelTransactionRow(data));
            this.tableFuelTotals.displayData(null, fuelRows, 0);

            const nonFuelTotals = this.activeRow.get("non_fuel_totals", []);
            const nonFuelRows = nonFuelTotals.map((data) => this.createFuelTransactionRow(data));
            this.tableNonFuelTotals.displayData(null, nonFuelRows, 0);

            const feesAndTaxes = this.activeRow.get("fees_and_taxes", []);
            const feesAndTaxesRows = feesAndTaxes.map((data) => this.createFuelTransactionRow(data));
            this.tableFeesAndTaxes.displayData(null, feesAndTaxesRows, 0);

            this.sourceFuelProductsHist.search({
                fuel_detail_id: this.activeRow.get("id")
            });

            this.textboxChainCode.quickInfoOverrideSearchMethod = async (layout, keyValue) => {
                if (!this.activeRow.isNull(this.textboxChainCode.field)) {
                    await layout.search({ interface_id: this.activeRow.get("interface_id"), code: this.activeRow.get("chain_code") });
                }
            }
        }
    }

    private createFuelTransactionRow(data) {
        return new ModelRow(this.mainDataSource.url, false, data);
    }

}
